document.addEventListener( 'DOMContentLoaded', function () {
	const page = document.querySelector( '.documents-page' );

	if ( ! page ) {
		return;
	}

	const list = page.querySelector( '[data-documents-list]' );
	const buttons = page.querySelectorAll( '.documents-page__categories-btn' );
	const select = document.getElementById( 'documents-categories-select' );
	const config = {
		ajaxUrl: page.dataset.ajaxUrl,
		nonce: page.dataset.nonce,
		defaultTermId: page.dataset.defaultTermId,
	};

	if ( ! list || ! config.ajaxUrl || ! config.defaultTermId ) {
		return;
	}

	let currentTermId = String( config.defaultTermId );
	let isLoading = false;

	function syncCustomSelect( selectEl ) {
		const wrapper = document.querySelector( `[data-custom-for="${ selectEl.id }"]` );

		if ( ! wrapper ) {
			return;
		}

		const dropdown = wrapper.querySelector( '.custom-dropdown' );
		const selectedEl = dropdown?.querySelector( '.custom-dropdown-selected' );
		const option = selectEl.options[ selectEl.selectedIndex ];

		if ( selectedEl && option ) {
			selectedEl.textContent = option.textContent;
		}

		dropdown?.classList.remove( 'not-selected' );

		dropdown?.querySelectorAll( '.custom-dropdown-list li' ).forEach( function ( li ) {
			li.classList.toggle( 'active', li.dataset.value === selectEl.value );
		} );
	}

	function setActive( termId ) {
		currentTermId = String( termId );

		buttons.forEach( function ( btn ) {
			const item = btn.closest( '.documents-page__categories-item' );

			btn.classList.toggle( 'active', item?.dataset.termId === currentTermId );
		} );

		if ( select && select.value !== currentTermId ) {
			select.value = currentTermId;
			syncCustomSelect( select );
		}
	}

	async function loadDocuments( termId ) {
		if ( isLoading || ! termId ) {
			return;
		}

		isLoading = true;
		list.classList.add( 'is-loading' );

		try {
			const body = new FormData();

			body.append( 'action', 'fd_get_documents' );
			body.append( 'nonce', config.nonce );
			body.append( 'term_id', termId );

			const response = await fetch( config.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			} );

			const data = await response.json();

			if ( data.success ) {
				list.innerHTML = data.data.html;
			}
		} catch ( error ) {
			console.error( 'documents-filter:', error );
		} finally {
			isLoading = false;
			list.classList.remove( 'is-loading' );
		}
	}

	function selectCategory( termId ) {
		if ( String( termId ) === currentTermId ) {
			return;
		}

		setActive( termId );
		loadDocuments( termId );
	}

	buttons.forEach( function ( btn ) {
		btn.addEventListener( 'click', function () {
			const item = btn.closest( '.documents-page__categories-item' );

			if ( item?.dataset.termId ) {
				selectCategory( item.dataset.termId );
			}
		} );
	} );

	if ( select ) {
		select.addEventListener( 'change', function () {
			selectCategory( select.value );
		} );

		syncCustomSelect( select );
	}

	setActive( config.defaultTermId );
} );
